angular.module('bbl.models', [
	'bbl.models.bridge'
]);

require('./bridge');


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/models/index.js
 ** module id = 127
 ** module chunks = 0
 **/